import { TextField } from '@mui/material';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const TextFormField = ({ fieldDef, type }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled, variant } = useFormFieldDef(fieldDef);
 

  return (
    
    <TextField
      fullWidth
      type={type}
      variant={variant}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={onBlur}
      error={!disabled && error}
      helperText={helperText}
      label={label}
      disabled={disabled}
    />
  );
};
